// DHL'in "Country With No Postal Code" listesi. Bu ülkelerde posta kodu girilmez,
// adres yalnızca şehirle tanımlanır.
const NO_POSTAL_CODE_COUNTRIES = new Set([
  'AE', 'AF', 'AG', 'AI', 'AL', 'AO', 'AW', 'BB', 'BF', 'BH', 'BI', 'BJ', 'BM', 'BO', 'BS',
  'BT', 'BW', 'BZ', 'CD', 'CF', 'CG', 'CI', 'CK', 'CL', 'CM', 'CR', 'CV', 'DJ', 'DM', 'DO',
  'EG', 'ER', 'ET', 'FJ', 'FK', 'GA', 'GD', 'GH', 'GI', 'GM', 'GN', 'GQ', 'GT', 'GW', 'GY',
  'HK', 'HN', 'HT', 'IQ', 'IR', 'JM', 'JO', 'KE', 'KI', 'KM', 'KN', 'KP', 'KW', 'KY', 'LA',
  'LB', 'LC', 'LR', 'LS', 'LY', 'ML', 'MM', 'MO', 'MR', 'MS', 'MT', 'MU', 'MW', 'MZ', 'NA',
  'NE', 'NG', 'NI', 'NP', 'NR', 'NU', 'OM', 'PA', 'PE', 'PY', 'QA', 'RW', 'SA', 'SB', 'SC',
  'SD', 'SL', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SY', 'TC', 'TD', 'TG', 'TL', 'TO', 'TT',
  'TV', 'TZ', 'UG', 'UY', 'VC', 'VE', 'VG', 'VN', 'VU', 'WS', 'YE', 'ZM', 'ZW',
  // DHL'in kendi kodları (XB Bonaire, XC Curaçao, XE St. Eustatius, XM St. Maarten,
  // XN Nevis, XS Somalia Hargeisa) ve ülke listemizdeki ISO karşılıkları.
  'XB', 'XC', 'XE', 'XM', 'XN', 'XS', 'BQ', 'CW', 'SX',
]);

export const isNoPostalCodeCountry = (countryCode) =>
  NO_POSTAL_CODE_COUNTRIES.has(String(countryCode || '').toUpperCase());

export default NO_POSTAL_CODE_COUNTRIES;
